import React, { useEffect, useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import "../Header/Header.css";
import logo from "../../images/logo.svg";
import logomobile from "../../images/mobile-logo.svg";

const Header = () => {
    const [scrolled, setScrolled] = useState(false);

    const handleScroll = () => {
        if (window.scrollY > 80) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const [expanded, setExpanded] = useState(false);

    const handleNavClick = () => {
        // Close the Navbar when a Nav.Link is clicked
        setExpanded(false);
    };
    
    const handleToggle = () => {
        setExpanded(!expanded);
    };

    return (
        <>
            <header className={`header ${scrolled ? 'sticky' : ''}`}>
                <Container>
                    <Navbar expand="lg" expanded={expanded}>
                        <Navbar.Brand href="#">
                            <img src={logo} alt='logo' className='img-fluid' />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle} />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Navbar.Brand href="#" className='d-block d-lg-none logo-mobile'>
                                <img src={logomobile} alt='logo' className='img-fluid' />
                            </Navbar.Brand>
                            <Nav>
                                <Nav.Link href="/home#features" onClick={handleNavClick}>Features</Nav.Link>
                                <Nav.Link href="/home#video" onClick={handleNavClick}>Demo Video</Nav.Link>
                                <Nav.Link href="/home#about" onClick={handleNavClick}>About us</Nav.Link>
                                <Nav.Link href="/home#reviews" onClick={handleNavClick}>Reviews</Nav.Link>
                                <Nav.Link href="/home#plan" onClick={handleNavClick}>Plans</Nav.Link>
                            </Nav>
                            <div className='header-right'>
                                <Link href='#' className='btn btn-white'>Login</Link>
                                <Nav.Link href='/home#star-for-free' onClick={handleNavClick} className='btn btn-black'>Start for Free</Nav.Link>
                            </div>
                        </Navbar.Collapse>
                    </Navbar>
                </Container>
            </header>
        </>
    )
}

export default Header;